import React, { useEffect, useState } from "react";
import { Card, Table, Space, Avatar, Select, Button } from "antd";
import { Dropdown } from "antd";
import { MoreOutlined, EyeOutlined, DownloadOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { searchProductsAction } from "appRedux/actions/myProductsAction";
import { useHistory } from "react-router-dom";
import { isArrayNonEmpty, isValidElement, isValidString } from "util/ApiHelper";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { fetchSuccess, fetchStart } from "../../appRedux/actions";
import { isVerifiedFreightEligible, logoFromString } from "../../util/helper";
import { BUSINESS_TYPE_LABEL, BUSINESS_TYPE_ID, BUSINESS_TYPE } from "../../util/Constant";
import { capitalize } from "lodash";
import EnquiryStatusTags from "../enquiries/EnquiriesStatus";
import { format } from 'date-fns';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import VerifiedFreightTag from "../../components/VerifiedFreightTag";

let navigateToDetails;

const MyUsersList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [userAdminData, setUserAdminData] = useState(null);
  const [businessTypeFilter, setBusinessTypeFilter] = useState(BUSINESS_TYPE.EXPORTER);

  const currentPage = 1;
  const dataSize = 10;

  const getStatusColor = (status) => {
    switch (status) {
      case "Pending":
        return "#faad14";
      case "Approved":
        return "#52c41a";
      case "Rejected":
        return "#f5222d";
      default:
        return "#1890ff";
    }
  };

  const StatusBadge = ({ status }) => {

    const normalisedStatus = status?.trim();
    const displayStatus = normalisedStatus ? normalisedStatus : "NA";

    return (
    <span
      style={{
        color: getStatusColor(normalisedStatus),
        fontWeight: "bold",
        padding: "4px 8px",
        borderRadius: "4px",
        backgroundColor: getStatusColor(normalisedStatus) + "20",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      {displayStatus}
    </span>
    )
  };

  const columns = [
    {
      title: "User Name",
      key: "User Name",
      dataIndex: "name",
      sorter: true,
      width: "25%",
      render: (text, record) => (
        <div className={"gx-flex-row gx-align-items-center"}>
          <div className={"gx-pr-2"}>
            <Avatar
              src={isValidString(record?.companyLogo) && record?.companyLogo}
              className="gx-avatar gx-pointer"
              alt=""
              style={{ height: 40, width: 40 }}
            >
              {!record?.companyLogo && logoFromString(text)}
            </Avatar>
          </div>
          <div className={"highlighted-column"}>{text}</div>
        </div>
      ),
    },
    {
      title: "Company Name",
      key: "companyName",
      render: (record) => <div>{record?.companyName}</div>,
    },
    {
      title: "Business Type",
      key: "businessType",
      render: (record) => {
        const businessTypeValue = BUSINESS_TYPE_ID[record?.businessTypeId];
        const businessTypeLabel = BUSINESS_TYPE_LABEL[businessTypeValue] || "Unknown";
        return <div>{businessTypeLabel}</div>;
      },
    },
    {
      title: "Freight Verification",
      key: "verifiedFreight",
      render: (record) =>
        isVerifiedFreightEligible(record) ? (
          <VerifiedFreightTag verifiedFreight={record?.verifiedFreight} />
        ) : (
          <div>-</div>
        ),
    },
    {
      title: "Mobile Number",
      key: "Mobile Number",
      sorter: true,
      width: "25%",
      render: (record) => <div>{record?.mobile}</div>,
    },
    {
      title: "Email",
      key: "Email",
      sorter: true,
      width: "25%",
      render: (record) => <div>{record?.email}</div>,
    },
    {
      title: "Date",
      key: "createdAt",
      render: (record) => (
        <div>
          {record?.createdAt
            ? format(new Date(record.createdAt), "MMMM dd, yyyy hh:mm a")
            : ''}
        </div>
      ),
    },
    {
      title: "Status",
      key: "Status",
      width: "25%",
      render: (record) => <StatusBadge status={record?.status} />,
    },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <div className="myexim-action-icon" onClick={(e) => e.stopPropagation()}>
          <Dropdown
            menu={{
              items: [
                {
                  label: "View Details",
                  key: "1",
                  icon: <EyeOutlined />,
                  onClick: () => {
                    navigateToDetails(record?.id);
                  },
                },
                {
                  label: "Edit Profile",
                  key: "2",
                  icon: <EyeOutlined />,
                  onClick: () => {
                    navigateProfileEdit(record?.id);
                  },
                },
              ],
            }}
            trigger={["click"]}
          >
            <Space>
              <MoreOutlined />
            </Space>
          </Dropdown>
        </div>
      ),
    },
  ];

  const getUsersListAPICCall = async (page, limit) => {
    const response = await axiosInstance.get(
      `${BASE_API_CONFIG.baseURL}/admin/users?&page=${page}&limit=${limit}`
    );
    setUserAdminData(response?.data?.data);
    dispatch(fetchSuccess());
  };

  useEffect(() => {
    dispatch(fetchStart());
    getUsersListAPICCall(currentPage, dataSize);
  }, [dispatch]);
  const [searchText, setSearchText] = useState(null);

  const searchProductList = useSelector(
    (state) => state.myProducts.searchProducts
  );

  const onShowSizeChange = (current, pageSize) => {
    getUsersListAPICCall(current, pageSize);
  };

  const onSearch = (e) => {
    if (isValidString(e?.target?.value)) {
      dispatch(searchProductsAction(e.target.value));
      setSearchText(e.target.value);
    }
  };
  navigateToDetails = (id) => {
    if (isValidElement(id)) {
      dispatch(fetchStart());
      history.push(`users/details?id=${id}`);
    }
  };

  const navigateProfileEdit = (id) => {
    if (isValidElement(id)) {
      dispatch(fetchStart());
      history.push(`/users/editProfile?id=${id}`);
    }
  };

  const tableData =
    isValidString(searchText) && searchText.length > 0
      ? isArrayNonEmpty(searchProductList?.rows)
        ? searchProductList
        : []
      : userAdminData;

  const filterRows = businessTypeFilter
    ? tableData?.rows?.filter((item) => {
        const itemBusinessType = BUSINESS_TYPE_ID[item?.businessTypeId];
        return itemBusinessType === businessTypeFilter;
      })
    : tableData?.rows;

  const downloadExcel = () => {
    const rows = filterRows || [];
    const dataToDownload = rows.flatMap((item) => {
      const businessTypeValue = BUSINESS_TYPE_ID[item.businessTypeId];
      const businessTypeLabel =
        BUSINESS_TYPE_LABEL[businessTypeValue] ||
        BUSINESS_TYPE_LABEL[item.businessTypeId] ||
        "Unknown";

      if (!Array.isArray(item.portPairs) || item.portPairs.length === 0) {
        return [
          {
            Name: item.name,
            Company: item.companyName,
            BusinessType: businessTypeLabel,
            Email: item.email,
            Mobile: item.mobile,
            Status: item.status,
            VerifiedFreight: isVerifiedFreightEligible(item)
              ? item.verifiedFreight
                ? "Verified Freight"
                : "Not Verified"
              : "-",
            "Loading Port": "-",
            "Destination Port": "-",
            CreatedAt: item.createdAt
              ? format(new Date(item.createdAt), "dd-MM-yyyy")
              : "-",
          },
        ];
      }

      return item.portPairs.map((pair) => {
        const [loadingPort, destinationPort] = pair
          .split("→")
          .map((p) => p.trim());

        return {
          Name: item.name,
          Company: item.companyName,
          BusinessType: businessTypeLabel,
          Email: item.email,
          Mobile: item.mobile,
          Status: item.status,
          VerifiedFreight: isVerifiedFreightEligible(item)
            ? item.verifiedFreight
              ? "Verified Freight"
              : "Not Verified"
            : "-",
          "Loading Port": loadingPort || "-",
          "Destination Port": destinationPort || "-",
          CreatedAt: item.createdAt
            ? format(new Date(item.createdAt), "dd-MM-yyyy")
            : "-",
        };
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToDownload);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "users.xlsx");
  };

  return (
    <Card
      title={
        <div style={{ display: "flex" }}>
          <div className="myexim-table-title">My Users</div>
          <Space>
            <Select
              value={businessTypeFilter}
              placeholder="Filter by Business Type"
              allowClear
              style={{ width: 220, marginLeft: "16px" }}
              onChange={(value) => setBusinessTypeFilter(value)}
            >
              {Object.keys(BUSINESS_TYPE_ID).map((key) => {
                const isId = !isNaN(key);
                if (isId) {
                  const businessTypeValue = BUSINESS_TYPE_ID[key];
                  const businessTypeLabel = BUSINESS_TYPE_LABEL[businessTypeValue] || 
                                           BUSINESS_TYPE_LABEL[key] || 
                                           capitalize(businessTypeValue);
                  return (
                    <Select.Option key={key} value={businessTypeValue}>
                      {businessTypeLabel}
                    </Select.Option>
                  );
                }
                return null;
              }).filter(Boolean)}
            </Select>

            <Button icon={<DownloadOutlined />} onClick={downloadExcel}>
              Download
            </Button>
          </Space>
        </div>
      }
    >
      <div>
        <Table
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          onRow={(record) => {
            return {
              onClick: (e) => {
                if (
                  !e.target.classList.contains(
                    "ant-dropdown-menu-title-content"
                  )
                ) {
                  navigateToDetails(record?.id);
                }
              },
            };
          }}
          className="gx-table-responsive my-product-table myexim-table"
          total={filterRows?.length}
          columns={columns}
          dataSource={filterRows}
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            pageSize: 10,
            total: filterRows?.length,
            onChange: onShowSizeChange,
          }}
        />
      </div>
    </Card>
  );
};

export default MyUsersList;
